import { WabunkaExperiencePreReservationPrice } from '@japan-culture-and-technology/wabunka-protos/ts_proto/wabunka_experience_pre_reservation_price';

import { useCurrency } from '@/wabunka-src/common/composables/general/useCurrency/useCurrency';
import type { WabunkaReservationForm } from '@/wabunka-src/features/Experience';
import { buildExperiencePreReservationPriceCalculateRequest, buildExperiencePreReservationPriceViewModel } from '@/wabunka-src/features/Experience';

/**
 * 料金テーブルの計算
 */
export const useWabunkaExperiencePreReservationPriceCalculationsForEvent = () => {
  const { selectedCurrency } = useCurrency();
  const calculate = async (form: Ref<WabunkaReservationForm>, currency?: string) => {
    const path = ref(`/experiencePreReservationPrices/calculate`);
    const resolvedCurrency = currency ?? selectedCurrency.value;

    // Nuxt 4 では同じ key のキャッシュが共有されるため、呼び出し毎にユニークな key を生成して
    // 常に最新の form 状態で再計算させる（POST のレスポンスをキャッシュすると古い料金が返る）
    const uniqueKey = `${path.value}-${resolvedCurrency}-${Date.now()}-${Math.random().toString(36).slice(2)}`;

    const { data, error } = await useFetchToPublicWabunkaApi({
      path,
      key: uniqueKey,
      body: ref(buildExperiencePreReservationPriceCalculateRequest(form.value, true, resolvedCurrency)),
      method: ref('POST'),
      options: { server: false },
      converter: WabunkaExperiencePreReservationPrice.fromJSON,
    });

    const preReservationPrice = computed(() => (data.value ? buildExperiencePreReservationPriceViewModel(data.value) : undefined));
    return { data: preReservationPrice, error: error.value };
  };

  return { calculate };
};
